import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const getCarMakeList = createAsyncThunk(
  'general/getCarMakeList',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await authGet('/general/list/carMake');
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export default getCarMakeList;
